module.exports = __webpack_public_path__ + "img/news-central.a8c2535e.jpg";